exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home-article-card{display:flex;flex-direction:column;height:100%}.home-article-title{align-items:flex-start;min-height:56px;overflow-wrap:anywhere;word-break:normal}.home-article-summary{flex:1 1 auto;min-height:70px;overflow-wrap:anywhere;white-space:pre-line}", ""]);

// exports
